import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { UserCheckIcon, UserIcon } from '@yonderland/andes-icons';
import { Breakpoint, Icon, IconButton, Link, LinkButton, useIsClient } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { NewAuthenticationContainer } from '../../containers/NewAuthenticationContainer';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { NewAccountMenuPopover } from '../account/account-menu/NewAccountMenuPopover';
import { SecurityLevelsPopup } from '../security-levels-popup/SecurityLevelsPopup';
const AccountMenuItem = ({ accountMenu, login, registration, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const dispatch = useDispatch();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const { authUrl, isLoggedIn, postLogin, logout } = useOAuth();
    const isClient = useIsClient();
    const [open, setOpen] = useState(false);
    const handleLogout = () => {
        logout();
    };
    const handleOpen = () => {
        setOpen(prev => !prev);
    };
    const handleSidebarClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (isClient) {
            if (!isNewAuth) {
                dispatch(sessionActions.createInitAction());
            }
        }
    }, [isClient]);
    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        postLogin();
    }, [isLoggedIn]);
    const triggerContent = (_jsxs(_Fragment, { children: [_jsx(Breakpoint, { from: "lg", children: isNewAuth && !isLoggedIn ? (_jsxs(Link, { testId: "login-button", theme: "neutral", variant: "tertiary", size: "sm", href: authUrl, children: [_jsx(Icon, { source: isLoggedIn ? UserCheckIcon : UserIcon, size: "xs" }), isLoggedIn ? t('account.account') : t('account.login.title.login')] })) : (_jsxs(LinkButton, { testId: "login-button", theme: "neutral", variant: "tertiary", size: "sm", onClick: handleOpen, children: [_jsx(Icon, { source: isLoggedIn ? UserCheckIcon : UserIcon, size: "xs" }), isLoggedIn ? t('account.account') : t('account.login.title.login')] })) }), _jsx(Breakpoint, { until: "lg", children: _jsx(IconButton, { icon: {
                        title: 'user icon',
                        source: isLoggedIn ? UserCheckIcon : UserIcon,
                        size: 'xs',
                        color: 'neutral',
                        testId: 'account',
                    }, variant: "plain", size: "sm", onClick: !isNewAuth || isLoggedIn ? handleOpen : undefined }) })] }));
    return (_jsx(_Fragment, { children: isClient &&
            (isLoggedIn === true ? (_jsxs(_Fragment, { children: [_jsx(NewAccountMenuPopover, { items: accountMenu.items, logout: handleLogout, triggered: open, onClose: handleSidebarClose, children: triggerContent }), _jsx(SecurityLevelsPopup, {})] })) : (_jsx(_Fragment, { children: _jsx(NewAuthenticationContainer, { actionUri: (!!login && login.actionUri) || undefined, onClose: handleSidebarClose, registrationLink: (!!registration && registration.link) || undefined, triggered: open, children: triggerContent }) }))) }));
};
export default AccountMenuItem;
